import { useTranslation } from 'react-i18next'
import lowerCase from 'lodash/lowerCase'
import { Inline, Stack, Text } from '@machobear/design-system'
import CurrencyFormatter from '@/components/currency-formatter'
import { Listing } from '../../types'

interface PriceDisplayProps {
  listing: Listing
}
export const PriceDisplay = ({ listing }: PriceDisplayProps) => {
  const { t } = useTranslation()

  if (!listing) {
    return null
  }

  const { gr_unit, gr_min_price, price_frequency, price } = listing

  if (gr_unit === '1') {
    return (
      <Stack space="xsmall">
        <Text tone="secondary" size="small">
          {t('Starting at')}
        </Text>
        <Inline space="xxxsmall" alignY="bottom">
          <Text tone="neutral" size="large" weight="strong">
            <CurrencyFormatter value={gr_min_price} prefix="$" />
          </Text>
          <Text tone="secondary" size="standard">
            {` / ${lowerCase(t(`b.listing.view.price_frequency_${price_frequency}.text`))}`}
          </Text>
        </Inline>
      </Stack>
    )
  }

  return (
    <Inline space="xxxsmall" alignY="bottom">
      <Text tone="neutral" size="large" weight="strong">
        <CurrencyFormatter value={price} prefix="$" />
      </Text>
      <Text tone="secondary" size="standard">
        {` / ${lowerCase(t(`b.listing.view.price_frequency_${price_frequency}.text`))}`}
      </Text>
    </Inline>
  )
}
